const absoluteUrlRegexp = new RegExp('(^|:)//');
const withoutTrailingSlash = (url: string) => url.replace(/\/$/, '');
const withoutLeadingSlash = (url: string) => url.replace(/^\//, '');

export function appendToBaseUrl(base: string, url: string): string {
    if (!base) {
        return url;
    }

    if (!url) {
        return base;
    }

    if (absoluteUrlRegexp.test(url)) {
        return url;
    }

    base = withoutTrailingSlash(base);
    url = withoutLeadingSlash(url);

    return `${base}/${url}`;
}
